import { Box } from '@mui/material'
import { useParams } from 'react-router-dom'

export function TransactionCrumb() {
  const { txid } = useParams()
  if (!txid) throw new Error('Param txid is required')
  return <Box sx={{ overflowWrap: 'anywhere' }}>{txid}</Box>
}
